// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1RbAs","signatureBlock":"Footer_signatureBlock__31oOt","signature":"Footer_signature__24FbF"};